export default __webpack_public_path__ + "static/media/RCU_Logo__white.1d052e93.svg";